import { FileText, CheckCircle } from 'lucide-react';

export const QuestionnairePanel = ({ questionnaireData, questionnaireStats }) => (
  <div className="mb-8" data-testid="questionnaires-section">
    <h2 className="text-2xl font-semibold text-[#00d1ff] mb-6 border-b border-[#00d1ff]/30 pb-3">
      FAN PERSPECTIVE QUESTIONNAIRES
    </h2>
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <div className="kpi-card p-6 rounded-lg" data-testid="questionnaire-stats">
        <div className="flex items-center justify-between mb-3">
          <FileText className="w-8 h-8 text-[#00d1ff]" />
          <CheckCircle className="w-5 h-5 text-[#00d1ff] opacity-60" />
        </div>
        <p className="text-gray-400 text-sm uppercase tracking-wide">Questionnaires Completed</p>
        <p className="text-3xl font-bold text-[#00d1ff] mt-2">{questionnaireStats.completed.toLocaleString()}</p>
      </div>
      <div className="lg:col-span-2 chart-container p-6 rounded-lg" data-testid="position-ratings">
        <h3 className="text-xl font-semibold text-[#00d1ff] mb-4">POSITION RATINGS</h3>
        {questionnaireData.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            <FileText className="w-12 h-12 mx-auto mb-3 opacity-30" />
            <p>No questionnaire responses yet</p>
          </div>
        ) : (
          <div className="space-y-3">
            {questionnaireData.map((response) => {
              const scoreColor = response.total_score > 9.0 ? 'text-[#00ff41] bg-[#00ff41]/10 border-[#00ff41]/30' : response.total_score < 6.0 ? 'text-[#ff0033] bg-[#ff0033]/10 border-[#ff0033]/30' : 'text-[#00d1ff] bg-[#00d1ff]/10 border-[#00d1ff]/30';
              return (
                <div key={response.id} className={`flex items-center justify-between p-4 rounded-lg border ${scoreColor} transition-all hover:scale-[1.02]`} data-testid={`rating-${response.id}`}>
                  <div className="flex items-center gap-4">
                    <span className="text-xs font-mono bg-black/30 px-3 py-1.5 rounded uppercase tracking-wider">{response.position_code}</span>
                    <span className="font-semibold text-base">{response.player_name}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-2xl font-bold">{response.total_score.toFixed(1)}</span>
                    <span className="text-xs opacity-60">/10</span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  </div>
);
